import { zohoWidget } from '../config';

function loadWidget() {
  if (document.getElementById('zsiqscript')) return;
  window.$zoho = window.$zoho || {};
  window.$zoho.salesiq = window.$zoho.salesiq || { ready: function () {} };
  const script = document.createElement('script');
  script.id = 'zsiqscript';
  script.defer = true;
  script.src = zohoWidget;
  document.body.appendChild(script);
}

function showWindow() {
  try {
    if (window.$zoho?.salesiq?.floatwindow?.visible) {
      window.$zoho.salesiq.floatwindow.visible('show');
      return true;
    }
  } catch {
    /* widget not ready yet */
  }
  return false;
}

export function openChat() {
  if (typeof window === 'undefined' || showWindow()) return;

  loadWidget();

  let attempts = 0;
  const poll = setInterval(() => {
    attempts += 1;
    if (showWindow() || attempts > 40) clearInterval(poll);
  }, 250);
}
